import React from 'react'
import styled from 'styled-components'

import LabelledField from 'components/LabelledField'

import { color } from 'styles/colors'

type props = {
  label?: string
  value: string | undefined
  options: Array<string>
  onSelectChange: (event) => void
  onInputChange: (event) => void
  onBlur: (event) => void
  className?: string
  autoFocus?: boolean
}

const ComboBox = ({ label = '', value, options, onSelectChange, onInputChange, onBlur, className, autoFocus = false, ...inputProps }: props) => (
  <S.TextField {...{ label, className }} id={label}>
    <S.Select onChange={onSelectChange}>
      {options.map((option) => (
        <option key={option} value={option}>{option}</option>
      ))}
    </S.Select>

    <S.Input
      autoFocus={autoFocus}
      id={label}
      value={value}
      onBlur={onBlur}
      onChange={onInputChange}
      {...inputProps}
    />
  </S.TextField>
)

const height = '39px'
const S = {
  TextField: styled(LabelledField)`
    height: ${height};
  `,
  Select: styled.select`
    height: ${height};
    margin-bottom: auto;
    padding-right: 25px;
    box-shadow: none;
  `,
  Input: styled.input`
    height: ${height};
    position: relative;
    bottom: ${height};
    width: calc(100% - 26px);
    padding-left: 6px;
    color: ${color('primaryText')};
    border: 1px solid ${color('border')};

    &:focus {
      outline: none;
    }
  `
}

export default ComboBox
